import React__default from 'react';
import { DEFAULT_ICON_SIZE } from './types.mjs';

const Chevron = ({ size = DEFAULT_ICON_SIZE, ...props })=>{
    return /*#__PURE__*/ React__default.createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 25 25",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React__default.createElement("path", {
        d: "M9.09 7.91L13.67 12.5L9.09 17.09L10.5 18.5L16.5 12.5L10.5 6.5L9.09 7.91Z",
        fill: "currentColor"
    }));
};

export { Chevron };
//# sourceMappingURL=chevron.mjs.map
